
import { Skeleton } from "primereact/skeleton";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import SystemContext from "../../../../../context/systemContext/context";
import formatCurrency from "../../../../utils/formatCurrency";
import { Container, ToggleBtn } from "./styles";

interface IBillingCardProps {
    label: string;
    value: string | number;
    icon?: JSX.Element;
    isMoney?: boolean;
    hasVisibleToggle?: boolean;
    color: string;
    isLoading: boolean;
    testFunc?: (log?: any) => {};
    visibleValue?: boolean;
}

export const BillingCard: React.FC<IBillingCardProps> = ({ value, label, icon, isMoney = false, hasVisibleToggle = false, color, isLoading = false, testFunc = () => { }, visibleValue = true }) => {
    const { t: translation } = useTranslation()
    const { systemConfig, update } = useContext(SystemContext)
    const [visible, setVisible] = useState(visibleValue)
    const [stateValue, setStateValue] = useState(value)

    useEffect(() => {
        if (visible) { 
            setStateValue(value)
        } else {
            setStateValue('**********')
        }
    }, [value])

    const hiddenValues = () => {
        if (visible) {
            if (label === translation('manager.billing.aggregate')) {
                update({...systemConfig, showBalance: false})
            }

            if (label === translation('manager.billing.transfer')) {
                update({...systemConfig, showTransfer: false})
            }            
            setStateValue('**********')
            setVisible(false)
            testFunc(false)
        } else {
            if (label === translation('manager.billing.aggregate')) {
                update({...systemConfig, showBalance: true})
            }
            
            if (label === translation('manager.billing.transfer')) {
                update({...systemConfig, showTransfer: true})
            }
            setStateValue(value)
            setVisible(true)
            testFunc(true)
        }
    }

    return (
        <>
            {isLoading ? (<Skeleton width="100%" height="120px" />) : (
                <Container style={isMoney ? { alignItems: 'left' } : { alignItems: 'center' }}>
                    <span>{label}</span>
                    <main style={isMoney ? { color: color, minWidth: 75 + "%" } : { color: color }}>
                        {icon}
                        {isMoney && visible ? (
                            <h5>{formatCurrency(stateValue)}</h5>
                        ) : (
                            <h5>{stateValue}</h5>
                        )}
                        {hasVisibleToggle && (
                            <ToggleBtn color={color} type="button" data-testid="toggle" onClick={hiddenValues}> {visible ? (<AiOutlineEyeInvisible size={30} />) : (<AiOutlineEye size={30} />)}</ToggleBtn>
                        )}
                    </main>
                </Container>
            )}
        </>
    )
}